// extracted by mini-css-extract-plugin
export default {"nutrientTable":"FXy_1UBTy8ZmB6Xc3nA9"};